export const faqs = [
  {
    q: '妖精动漫这个页面主要提供什么内容？',
    a: '本页把新番推荐、无修资源索引、里番合集与追番时间表集中在一起，并配热度排行与频道分类，方便你在一个页面内完成“选番—看简介—找合集—排追番顺序”的全过程。',
  },
  {
    q: '怎样快速找到自己想看的类型？',
    a: '可以在「新番推荐」区域用季度标签与频道标签双向筛选，也可以到「频道分类」点击任一频道，页面会自动滚动并帮你筛出该频道的作品。',
  },
  {
    q: '新番、补番和深夜档有什么区别？',
    a: '新番指本季正在更新、可以追更的连载；补番是已完结、适合一口气看完的作品；深夜档则是播出时间较晚、内容更偏成年向氛围的条目，分类只是入口标签，具体以条目简介为准。',
  },
  {
    q: '页面上的內容多久更新？',
    a: '本页内容为示例性整理，条目信息会在版本迭代中补充与调整。追番时间表按星期划分，仅为观看顺序参考，实际更新时间以条目说明为准。',
  },
  {
    q: '「无修资源」是什么意思？',
    a: '指同一部作品存在不同剪辑版本时，本页会标注版本差异并做索引说明，方便你在开始观看前确认要看的是哪一个版本，页面只提供条目信息，不提供片源。',
  },
  {
    q: '追番清单会保存吗？',
    a: '点击条目上的「加入追番」即可生成一份本地清单，方便集中查看感兴趣的作品；该清单仅保存在你自己的浏览器中，关闭页面后再次打开仍可查看，不涉及账号登录。',
  },
];